import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.darkBlue};
  padding: ${({ theme }) => theme.padding.large}
    ${({ theme }) => theme.padding.medium};
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.borderRadius.xlarge}
    ${({ theme }) => theme.borderRadius.xlarge} 0 0;
  color: ${({ theme }) => theme.colors.offWhite};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.medium};

  p {
    margin: 0;
  }

  @media (max-width: 1024px) {
    border-radius: ${({ theme }) => theme.borderRadius.large}
      ${({ theme }) => theme.borderRadius.large} 0 0;
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular};
  }
  @media (max-width: 767px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
    border-radius: ${({ theme }) => theme.borderRadius.medium}
      ${({ theme }) => theme.borderRadius.medium} 0 0;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.small};
  }

  @media (min-width: 2500px) {
    padding: 52px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3500px) {
    padding: ${({ theme }) => theme.padding.xlarge} 1.5dvw;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.spacingTablet};
  }
`;

export const LogoLink = styled(Link)`
  display: flex;
  gap: 0;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.text};

  img {
    height: auto;
    transition: height 0.3s ease;

    @media (min-width: 2500px) {
      height: 82px;
    }
    @media (min-width: 3000px) {
      height: 92px;
    }
    @media (min-width: 3400px) {
      height: 112px;
    }
    @media (min-width: 3800px) {
      height: 132px;
    }
    @media (min-width: 4500px) {
      height: 152px;
    }
    @media (min-width: 5000px) {
      height: 172px;
    }
  }
`;

export const CompanyInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.typography.small.fontSize};

  @media (max-width: 767px) {
    display: none;
  }

  p {
    @media (min-width: 2500px) {
      font-size: ${({ theme }) => theme.typography.body.fontSize};
    }
    @media (min-width: 3000px) {
      font-size: 1.5rem;
    }
    @media (min-width: 3400px) {
      font-size: 1.75rem;
    }
    @media (min-width: 3800px) {
      font-size: 2.25rem;
    }
    @media (min-width: 4500px) {
      font-size: 2.5rem;
    }
    @media (min-width: 5000px) {
      font-size: 3rem;
    }
  }
`;

export const CompanyInfoBlockMobile = styled.div`
  display: none;
  flex-direction: column;
  font-size: ${({ theme }) => theme.typography.small.fontSize};

  @media (max-width: 767px) {
    display: flex;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  justify-content: flex-end;

  @media (max-width: 767px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }

  @media (min-width: 3000px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (min-width: 3800px) {
    gap: 30px;
  }
`;

export const NavLink = styled.span`
  text-decoration: none;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.offWhite};
  transition: color 0.4s, background-color 0.4s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }

  &:focus {
    color: ${({ theme }) => theme.colors.accent};
  }

  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.5rem;
  }
  @media (min-width: 3800px) {
    font-size: 3rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;
  }
`;

export const ContactUs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  justify-content: flex-end;

  @media (min-width: 3000px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;

export const ContactLine = styled.a`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  color: ${({ theme }) => theme.colors.offWhite};
  transition: color 0.4s, border-bottom 0.4s;
  text-decoration: none;
  align-items: center;

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }

  &:focus {
    color: ${({ theme }) => theme.colors.accent};
  }

  @media (max-width: 1024px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 1.75rem;

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (min-width: 3400px) {
    font-size: 2.5rem;
    gap: 30px;

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3800px) {
    font-size: 3rem;

    svg {
      width: 52px;
      height: 52px;
    }
  }
  @media (min-width: 4500px) {
    font-size: 3.25rem;

    svg {
      width: 56px;
      height: 56px;
    }
  }
  @media (min-width: 5000px) {
    font-size: 3.75rem;

    svg {
      width: 64px;
      height: 64px;
    }
  }
`;

export const ContactUsLink = styled.span`
  display: flex;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.small};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.offWhite};
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.offWhite};
  width: fit-content;
  transition: color 0.4s, border-bottom 0.4s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
    border-bottom: 1px solid ${({ theme }) => theme.colors.darkBlue};
  }

  &:focus {
    color: ${({ theme }) => theme.colors.accent};
    border-bottom: 1px solid ${({ theme }) => theme.colors.darkBlue};
  }

  @media (max-width: 1024px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }

  @media (min-width: 2500px) {
    font-size: 1.75rem;
  }
  @media (min-width: 3000px) {
    font-size: 2rem;
  }
  @media (min-width: 3400px) {
    font-size: 2.5rem;
  }
  @media (min-width: 3800px) {
    font-size: 3rem;
  }
  @media (min-width: 4500px) {
    font-size: 3.5rem;
  }
  @media (min-width: 5000px) {
    font-size: 4rem;
  }
`;

export const PrivacyPolicy = styled(ContactUsLink)`
  font-size: ${({ theme }) => theme.typography.regular.fontSize};
  margin-top: ${({ theme }) => theme.spacing.regular};

  @media (min-width: 3000px) {
    margin-top: ${({ theme }) => theme.spacing.medium};
  }

  p {
    @media (min-width: 2500px) {
      font-size: 1.5rem;
    }
    @media (min-width: 3000px) {
      font-size: 1.75rem;
    }
    @media (min-width: 3400px) {
      font-size: 2rem;
    }
    @media (min-width: 3800px) {
      font-size: 2.5rem;
    }
    @media (min-width: 4500px) {
      font-size: 3rem;
    }
  }
`;

export const ConsentLink = styled(PrivacyPolicy)`
  margin-top: ${({ theme }) => theme.spacing.xsmall};

  @media (min-width: 3000px) {
    margin-top: ${({ theme }) => theme.spacing.xsmall};
  }
`;

export const ApplicationSection = styled.section`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.padding.medium};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge}
    ${({ theme }) => theme.borderRadius.xlarge} 0 0;
  background-color: ${({ theme }) => theme.colors.lightGreyBlue};
  align-items: center;

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.padding.large};
    border-radius: ${({ theme }) => theme.borderRadius.large}
      ${({ theme }) => theme.borderRadius.large} 0 0;
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.medium}
      ${({ theme }) => theme.spacing.small};
    border-radius: ${({ theme }) => theme.borderRadius.medium}
      ${({ theme }) => theme.borderRadius.medium} 0 0;
  }

  @media (min-width: 2500px) {
    padding: 100px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3500px) {
    padding: 130px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 150px 1.5dvw;
  }
  @media (min-width: 4500px) {
    padding: 4dvw 1.5dvw;
  }
`;

export const FooterSection = styled.section`
  background-color: ${({ theme }) => theme.colors.lightGreyBlue};
`;

export const ApplicationFooterReveal = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
